/**
 * Measures the execution time of a function in milliseconds.
 * Works with both synchronous and asynchronous functions.
 * @param fn The function to measure
 * @returns The execution time in milliseconds along with the function's result
 */
export async function measureTime<T>(
  fn: () => T | Promise<T>,
): Promise<{ result: T; executionTimeMs: number }> {
  const start = performance.now()
  const result = await fn()
  const end = performance.now()

  return {
    result,
    executionTimeMs: end - start,
  }
}
